import { Grid, TablePagination, Typography } from "@mui/material";
import { dateTimeFormat } from "../../../util/DateUtil";
import { currencyRound } from "../../../util/DoubleUtil";
import TablePaginationActions from "../../../shared/components/Table/Actions";

const CantinaExtratoPageView = ({ pageCantinaExtrato, handleChangePage }) => {
    return (
        <Grid container spacing={3}>
            <Grid size={12}>
                <Typography variant='h6'>Extrato</Typography>
            </Grid>
            {pageCantinaExtrato.content.map((cantinaExtrato) =>
                <Grid key={cantinaExtrato.codigo} size={12}>
                    <p>Tipo Extrato: {cantinaExtrato.tipoExtratoCantinaEnum}</p>
                    <p>Valor Extrato: {currencyRound(cantinaExtrato.valorExtrato)}</p>
                    <p>Data Hora Criação: {dateTimeFormat(cantinaExtrato.dataHoraCriacao)}</p>
                    <p>Valor Saldo Anterior: {currencyRound(cantinaExtrato.valorSaldoAnterior)}</p>
                </Grid>)
            }
            <Grid size={12}>
                <TablePagination
                    rowsPerPageOptions={[]}
                    rowsPerPage={pageCantinaExtrato.size ? pageCantinaExtrato.size : 0}
                    component="div"
                    count={pageCantinaExtrato.totalElements}
                    page={pageCantinaExtrato.number}
                    onPageChange={handleChangePage}
                    labelDisplayedRows={({ from, to, count }) => (from + "-" + to + " de " + (count !== -1 ? count + " registros" : + " mais de " + to))}
                    ActionsComponent={TablePaginationActions}
                />
            </Grid>
        </Grid>
    );
}

export default CantinaExtratoPageView;